import { createReducer, on } from '@ngrx/store';
import { User } from '../../core/models/user.model';
import { Notification } from '../../core/models/notification.model';
import * as UserActions from './user.actions';

export interface UserState {
  currentUser: User | null;
  notifications: Notification[];
  unreadCount: number;
  theme: 'light' | 'dark' | 'system';
  language: string;
  isLoading: boolean;
}

export const initialUserState: UserState = {
  currentUser: null,
  notifications: [],
  unreadCount: 0,
  theme: 'system',
  language: 'en',
  isLoading: false
};

export const userReducer = createReducer(
  initialUserState,

  on(UserActions.setUser, (state, { user }) => ({
    ...state, currentUser: user
  })),

  on(UserActions.clearUser, state => ({
    ...state, currentUser: null, notifications: [], unreadCount: 0
  })),

  on(UserActions.loadNotificationsSuccess, (state, { notifications }) => ({
    ...state, notifications
  })),

  on(UserActions.setUnreadCount, (state, { count }) => ({
    ...state, unreadCount: count
  })),

  on(UserActions.markNotificationRead, (state, { notificationId }) => ({
    ...state,
    notifications: state.notifications.map(n =>
      n.id === notificationId ? { ...n, isRead: true } : n
    ),
    unreadCount: Math.max(0, state.unreadCount - 1)
  })),

  on(UserActions.markAllNotificationsRead, state => ({
    ...state,
    notifications: state.notifications.map(n => ({ ...n, isRead: true })),
    unreadCount: 0
  })),

  on(UserActions.setTheme, (state, { theme }) => ({ ...state, theme })),
  on(UserActions.setLanguage, (state, { language }) => ({ ...state, language })),

  on(UserActions.awardXp, (state, { gain }) => {
    if (!state.currentUser) return state;
    const prev = state.currentUser.progress;
    return {
      ...state,
      currentUser: {
        ...state.currentUser,
        progress: {
          ...prev,
          totalXp: (prev.totalXp ?? 0) + gain.total,
        },
      },
    };
  })
);
